/**
 * Headers must match the site `popupCsv` export column names and order exactly
 * (import validation is positional). Import table UI labels may differ; parsing maps
 * these columns into the structured form fields.
 */

import { POPUP_GROUP_DISTRIBUTION_LABELS } from "../PopupGroupForm/popupGroupDistributionLabels";

const imageBlockHeaders = (n: number) =>
  [
    `画像${n}URL`,
    `画像${n}YDAコード`,
    `画像${n}画像が表示されない場合の表記`,
    `画像${n}画像クリック時のURL`,
    `画像${n}クエリパラメータを引き継ぐ（※ページの?以降の文字を引き継ぎます）`,
  ] as const;

const imageHeaders = () =>
  Array.from({ length: 8 }, (_, i) => [...imageBlockHeaders(i + 1)]).flat();

export const POPUP_IMPORT_CSV_HEADERS = [
  "ポップアップID",
  "ポップアップ名",
  "ポップアップグループID",
  "ポップアップグループ名",
  "ファネルID",
  "ファネル名",
  "実施するページURL",
  "メモ",
  "実施開始日",
  "実施終了日",
  "実施時刻",
  "実施曜日",
  "再表示禁止期間",
  "デバイス",
  "プラットフォーム",
  "ブラウザ",
  "性別",
  "年齢",
  "年収",
  "表示条件に流入元カテゴリを追加する",
  "非表示条件に流入元カテゴリを追加する",
  "表示条件に流入元を追加する",
  "表示条件に除外流入元を追加する",
  "表示条件にユーザーの訪問回数を追加",
  POPUP_GROUP_DISTRIBUTION_LABELS.displayTargetContents,
  POPUP_GROUP_DISTRIBUTION_LABELS.disableTargetElements,
  POPUP_GROUP_DISTRIBUTION_LABELS.deliverTargetUrls,
  POPUP_GROUP_DISTRIBUTION_LABELS.deliverExcludeUrls,
  POPUP_GROUP_DISTRIBUTION_LABELS.targetCookies,
  "マルチ配信",
  "配信方法",
  "配信比率",
  "ポップアップの種類",
  ...imageHeaders(),
  "閉じるボタンの表示",
  "ポップアップの幅",
  "スマートフォンポップアップの幅",
  "配色デザイン",
  "タイトル",
  "説明文",
  "ボタンテキスト",
  "クリック時のURL",
  "クエリパラメータを引き継ぐ（※ページの?以降の文字を引き継ぎます）",
  "クリック時のタブの扱い",
  "表示タイミング",
  "タブの切り替えで表示",
  "ポインタが外れた際にポップアップを表示",
  "15秒ユーザー操作がない場合ポップアップを表示",
  "（コード）",
  "表示場所",
  "背景の操作",
  "背景をクリック時にポップアップを非表示にする",
  "背景濃度",
  "スクロール率制限",
  "入力中にポップアップを表示させない",
  "表示時間",
  "表示回数を制限",
  "再表示ボタン",
  "再表示ボタン用画像",
  "再表示ボタン用メッセージ",
  "アニメーション",
  "YDAコード",
  "YDAコードトリガー",
  "ステータス",
] as const;

export type PopupImportCsvHeader = typeof POPUP_IMPORT_CSV_HEADERS[number];

/** Optional first column for hand-made sheets */
export const POPUP_IMPORT_ACTION_HEADER = "アクション" as const;
